/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SaveDashboardLayoutRequestBody,
  SaveDashboardLayoutRequestBody$Outbound,
  SaveDashboardLayoutRequestBody$outboundSchema,
} from "../components/savedashboardlayoutrequestbody.js";

export type SaveDashboardLayoutSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SaveDashboardLayoutRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  saveDashboardLayoutRequestBody: SaveDashboardLayoutRequestBody;
};

/** @internal */
export type SaveDashboardLayoutSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SaveDashboardLayoutSecurity$outboundSchema: z.ZodMiniType<
  SaveDashboardLayoutSecurity$Outbound,
  SaveDashboardLayoutSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function saveDashboardLayoutSecurityToJSON(
  saveDashboardLayoutSecurity: SaveDashboardLayoutSecurity,
): string {
  return JSON.stringify(
    SaveDashboardLayoutSecurity$outboundSchema.parse(
      saveDashboardLayoutSecurity,
    ),
  );
}

/** @internal */
export type SaveDashboardLayoutRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SaveDashboardLayoutRequestBody: SaveDashboardLayoutRequestBody$Outbound;
};

/** @internal */
export const SaveDashboardLayoutRequest$outboundSchema: z.ZodMiniType<
  SaveDashboardLayoutRequest$Outbound,
  SaveDashboardLayoutRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    saveDashboardLayoutRequestBody:
      SaveDashboardLayoutRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      saveDashboardLayoutRequestBody: "SaveDashboardLayoutRequestBody",
    });
  }),
);

export function saveDashboardLayoutRequestToJSON(
  saveDashboardLayoutRequest: SaveDashboardLayoutRequest,
): string {
  return JSON.stringify(
    SaveDashboardLayoutRequest$outboundSchema.parse(saveDashboardLayoutRequest),
  );
}
